

//-------imports-----------
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  FormControl,
  Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,  useMediaQuery,
  Autocomplete, Typography,
  Paper,  
  Chip,
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { useLocation } from "react-router-dom";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_STATUS_KITCHEN,
  CON_MAX_FILESIZE_ITEMIMG,
  CON_MENUICON_WIDTH,
  CON_MENUICON_HEIGHT,
} from "../../utils/sys/Constants";
import {
  BUSINESSTYPECODE,
  InvCategory_01,
  InvProduct_01,
  InvSubCategory_01,
  SETTINGS_API_08,
  SETTINGS_API_26,
  SETTINGS_API_27,
} from "../../api/ApiModel";
import { useSelector } from "react-redux";
import ImageCropper from "../../components/common/ImageCropper";
const names = [
  { label: "Food Items", value: "F" },
  { label: "Beverages", value: "B" },
];

const options = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
];

const AddProduct = () => {
  //----------------hooks---------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error1, setError1] = useState(null);
  const [data2, setData2] = useState([]);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [dataitem, setDataitem] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [errors, setErrors] = useState({});
  const [datacat, setDatacat] = useState([]);
    const [croppedImg, setCroppedImg] = useState("");   
  const [datacat1, setDatacat1] = useState([]);
   const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const isEdit = location.state?.actionText === "Edit";
  const isSmallScreen = useMediaQuery("(max-width:600px)");
    const marginLeftImage = isSmallScreen
    ? selectedImageUrl
      ? 60
      : 60
    : selectedImageUrl
    ? 115
    : 95;
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    productcode: "",
    catcode: "",
    subcatcode: "",
    productname: "",
    productsize: "",
    minorderlevel: "",
    descrip: "",
    barcodeimage: "",
    opstock: 0,
    opstockdate: "",
    istaxapply: "",
    taxcode: "",
    immeasuringunit: "",
    imagepath: "",
    imagebytearr:"",
      immeasuringunitcode:""
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        productcode: selectedItem.PRODUCTCODE || "",
        catcode: String(selectedItem.CATCODE) || "",
        subcatcode: String(selectedItem.SUBCATCODE) || "",
        productname: selectedItem.PRODUCTNAME || "",
        productsize: selectedItem.PRODUCTSIZE || "",
        minorderlevel: String(selectedItem.MINORDERLEVEL) || "",
        descrip: selectedItem.DESCRIP || "",
        barcodeimage: selectedItem.BARCODEIMAGE || "",
        opstock: selectedItem.OPSTOCK || 0,
        opstockdate: selectedItem.OPSTOCKDATE || "",
        istaxapply: selectedItem.ISTAXAPPLY || "",
        taxcode: selectedItem.TAXCODE || "",
        immeasuringunit: selectedItem.IMMEASURINGUNIT || "",
        immeasuringunitcode: selectedItem.IMMEASURINGUNITCODE || "",
        selectedImageUrl: selectedItem.IMAGEPATH || "",
        imagebytearr: selectedItem.IMAGEBYTEARR || "",
        sts: selectedItem.STS || "A",
        enuser: USERNAME || "",
      });
    }
  }, [selectedItem, USERNAME]);

    



  useEffect(() => {

    fetchDataunits();
  }, []);

  //------------------function------------

  //   useEffect(() => {
  //       const fetchData = async () => {
  //   try {
  //     const result = await externalgetApi(InvProduct_01, "get", {
  //       COMPCODE,
  //       CATCODE: selectedItemDetails.catcode,
  //       SUBCATCODE: selectedItemDetails.subcatcode,

  //       STS: CON_STATUS_ACTIVE,
  //     });
  //     setDataitem(result);
  //   } catch (err) {
  //     setError(err);
  //   }
  // };
  //   fetchData();
  //   }, [selectedItemDetails.catcode, selectedItemDetails.subcatcode]);
  const fetchDataunits = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_27, "get", {
        COMPCODE,
        LOCCODE,
      

        STS: CON_STATUS_ACTIVE,
      });
      console.log("API response:", result); // Log API response

      setData2(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(InvCategory_01, "get", {
          COMPCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDatacat(result);
        console.log("result", result);
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(InvSubCategory_01, "get", {
          COMPCODE,

          CATCODE: selectedItemDetails.catcode ,
          STS: CON_STATUS_ACTIVE,
        });

        setDatacat1(result);
        console.log("result", result);
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, [selectedItemDetails.catcode]);
  // handlers
 const cleanInputValue = (name, value) => {
  if (typeof value !== "string") return value;

  // Example: clean leading spaces for all inputs, or per field if needed
  return value.replace(/^\s+/, ""); // remove leading spaces
};

  const handleCroppedImage = (img) => {
    setCroppedImg(img);

    console.log("Received cropped image from child:", img);
  };

const handleInputChange = (e) => {
  const { name, value } = e.target;

  // Auto-clean the input (remove leading spaces)
  const cleanedValue = cleanInputValue(name, value);
  const trimmedValue = typeof cleanedValue === "string" ? cleanedValue.trim() : cleanedValue;

  // Prevent initial space only (optional after clean)
  if (typeof value === "string" && value.length === 1 && value[0] === " ") {
    return;
  }

  // Validate max length
  if (typeof cleanedValue === "string" && cleanedValue.length > 30) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "Input cannot exceed 30 characters.",
    }));
    return;
  }

  // Validate empty or space-only input
  if (typeof cleanedValue === "string" && trimmedValue === "") {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "Input cannot be empty or just spaces.",
    }));
  } else {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  }

  // Always update with the cleaned value
  setSelectedItemDetails((prevDetails) => ({
    ...prevDetails,
    [name]: cleanedValue,
  }));
};

const handlenumInputChange = (e) => {
  const { name, value } = e.target;
  const trimmedValue = typeof value === "string" ? value.trim() : value;

  // Prevent initial space only
  if (typeof value === "string" && value.length === 1 && value[0] === " ") {
    return;
  }

  // Validate numeric input (allow integers and floats, but not just ".")
  const isNumeric = /^[0-9]*\.?[0-9]*$/.test(value) && value !== ".";
  if (!isNumeric) {
    setErrors((prevError) => ({
      ...prevError,
      [name]: "Input must contain only numbers or decimals.",
    }));
    return; // Prevent state update if input is not numeric
  }

  // Clear the value if it is "0"
  if (value === "0") {
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: "",
    }));
    setErrors((prevError) => ({
      ...prevError,
      [name]: "",
    }));
    return;
  }

  // Clear error if input is valid
  setErrors((prevError) => ({
    ...prevError,
    [name]: "",
  }));

  // Always update the value
  setSelectedItemDetails((prevDetails) => ({
    ...prevDetails,
    [name]: value,
  }));
};
  //postapi
  const handleConfirmClick = async () => {
    const {
      catcode,
      subcatcode,
      subcatname,
      productname,
      productsize,
    } = selectedItemDetails;

 const requiredFields = [
  { name: "catcode", value: catcode, label: "Category Name" },
  { name: "subcatcode", value: subcatcode, label: "Subcategory Name" },
  { name: "productname", value: productname, label: "Product Name" },
  { name: "productsize", value: productsize, label: "Product Size" },
  { name: "immeasuringunit", value: selectedItemDetails.immeasuringunit, label: "Measuring Unit" },
  { name: "minorderlevel", value: selectedItemDetails.minorderlevel, label: "Minimum Order Level" },
];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setErrors(newError);
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage);
      setOpenErrorSnackbar(true);
      return;
    }

if (dataitem) {
  const isDuplicate = dataitem.some((item) => {
    return (
      String(item.CATCODE) === String(selectedItemDetails.catcode) && // Check within selected category
      String(item.SUBCATCODE) === String(selectedItemDetails.subcatcode) && // Check within selected subcategory
      typeof item.PRODUCTNAME === "string" &&
      typeof productname === "string" &&
      item.PRODUCTNAME.trim().toLowerCase() === productname.trim().toLowerCase() &&
      String(item.PRODUCTCODE) !== String(selectedItemDetails.productcode) // Allow editing without self-match
    );
  });

  if (isDuplicate) {
    setSnackbarMessage("Product name already exists under this Category and Subcategory.");
    setOpenErrorSnackbar(true);
    return;
  }
}

    const staticValues = {
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME || "",
      imagebytearr: croppedImg.length > 0 ? String(croppedImg.split(",")[1]) : "",
      COMPCODE: COMPCODE || "",
      BUSINESSTYPECODE,
      LOCCODE: LOCCODE ,
      brandcode: 0,
      packagecode: 0,
   
      packageunit: "",
      // immeasuringunitcode: 1023, 
 catname: "", // Set if you have catname
    subcatname: "", // Set if you have subcatname
    brandname: "", // Set if you have brandname
    packagename: "", // Set if you have packagename

    };

    const payload = {
      ...selectedItemDetails,

      ...staticValues,
      productcode: String(selectedItemDetails.productcode) || "0",
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(InvProduct_01, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        productcode: "",
        catcode: "",
        subcatcode: "",
        productname: "",
        productsize: "",
        minorderlevel: "",
        barcode: "",
        descrip: "",
        barcodeimage: "",
        opstock: 0,
        opstockdate: "",
        istaxapply: "",
        taxcode: "",
        measuringunit: "",
        imagepath: "",
        imagebytearr: "",
        selectedImageUrl: "",

        sts: "A",
        enuser: USERNAME || "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/ViewProduct");
    }, 2000);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      catname: "",
      colorcode: "",
      productcode: "",
      catcode: "",
      subcatcode: "",
      productname: "",
      productsize: "",
      minorderlevel: "",
      barcode: "",
      descrip: "",
    
      barcodeimage: "",
      opstock: 0,
      imagebytearr: "",
      selectedImageUrl: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const gotToView = () => {
    navigate("  ");     
  };
  //validations



  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Setting</Link>
                <Link underline="hover">Product</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit ? "Edit Product " : "Create Product",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid container item spacing={2} xs={12} sm={12} md={12} lg={12}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Autocomplete
                options={isEdit ? [] : Array.isArray(datacat) ? datacat : []}
                getOptionLabel={(option) => option.CATNAME || ""}
                 getOptionDisabled={() => isEdit} // disables all options if isEdit is true
                disableClearable
                value={
    Array.isArray(datacat)
      ? datacat.find(
          (item) => String(item.CATCODE) === String(selectedItemDetails.catcode)
        ) || null
      : null
  }
  onChange={(event, newValue) => {
    setSelectedItemDetails((prev) => ({
      ...prev,
      catcode: newValue ? String(newValue.CATCODE) : "",
    }));
    if (newValue) {
      setErrors((prev) => ({
        ...prev,
        catcode: "", // Clear the error
      }));
    }
  }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="catcode"
                    label={
                      <span>
                        Category Name<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                    error={Boolean(errors.catcode)}
                    helperText={errors.catcode}
                    size="small"
                    disabled={isEdit}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Autocomplete
               
                  options={isEdit ? [] : Array.isArray(datacat1) ? datacat1 : []}
                getOptionLabel={(option) => option.SUBCATNAME || ""}
                 getOptionDisabled={() => isEdit} // disables all options if isEdit is true
                disableClearable
                value={
                  Array.isArray(datacat1)
                    ? datacat1.find(
                        (item) =>
                          String(item.SUBCATCODE) ===
                          String(selectedItemDetails.subcatcode)
                      ) || null
                    : null
                }
                onChange={(event, newValue) => {
                  setSelectedItemDetails((prev) => ({
                    ...prev,
                    subcatcode: newValue ? String(newValue.SUBCATCODE) : "",
                  }));
                  if (newValue) {
                    setErrors((prev) => ({
                      ...prev,
                      subcatcode: "", // Clear the error
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="subcatcode"
                    label={
                      <span>
                        Subcategory Name
                        <span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    variant="outlined"
                    error={Boolean(errors.subcatcode)}
                    helperText={errors.subcatcode}
                    size="small"
                    disabled={isEdit}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label={
                  <span>
                    Product Name
                    <span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="productname"
                value={selectedItemDetails.productname}
                onChange={handleInputChange}
                error={Boolean(errors.productname)}
                helperText={errors.productname}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                  label={
    <span>
      Product Size<span style={{ color: "red" }}> *</span>
    </span>
  }
                name="productsize"
                value={selectedItemDetails.productsize}
                onChange={handleInputChange}
                size="small"
                fullWidth
                error={Boolean(errors.productsize)}
                helperText={errors.productsize}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label={
    <span>
      Minimum Order Level<span style={{ color: "red" }}> *</span>
    </span>
  }
                name="minorderlevel"
                value={selectedItemDetails.minorderlevel}
                onChange={handlenumInputChange}
                size="small"
                fullWidth
            error={Boolean(errors.minorderlevel)}
    helperText={errors.minorderlevel}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Description"
                name="descrip"
                value={selectedItemDetails.descrip}
                onChange={handleInputChange}
                size="small"
                fullWidth
                error={Boolean(errors.descrip)}
                helperText={errors.descrip}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth size="small">
              <Autocomplete
  options={Array.isArray(data2) ? data2 : []}
  getOptionLabel={(option) => option.IMMEASURINGUNIT || ""}
  disableClearable
  value={
    Array.isArray(data2)
      ? data2.find(
          (item) =>
            String(item.IMMEASURINGUNIT) === String(selectedItemDetails.immeasuringunit)
        ) || null
      : null
  }
  onChange={(event, newValue) => {
    setSelectedItemDetails((prev) => ({
      ...prev,
      immeasuringunit: newValue ? newValue.IMMEASURINGUNIT : "",
        immeasuringunitcode: newValue ? newValue.IMMEASURINGUNITCODE : "",
    }));
    setErrors((prevError) => ({
      ...prevError,
      immeasuringunit: "", // Clear error on change
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
       label={
          <span>
            Measuring Unit<span style={{ color: "red" }}> *</span>
          </span>
        }
      size="small"
      name="immeasuringunit"
      error={Boolean(errors.immeasuringunit)}
      helperText={errors.immeasuringunit}
    />
  )}
  ListboxProps={{
    style: {
      maxHeight: 150,
      backgroundColor: theme.palette.background.paper,
    },
  }}
/>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={options}
                  getOptionLabel={(option) => option.label}
                  disableClearable
                  value={
                    options.find(
                      (option) =>
                        option.value === selectedItemDetails.istaxapply
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setSelectedItemDetails((prev) => ({
                      ...prev,
                      istaxapply: newValue ? newValue.value : "",
                    }));
                    setErrors((prevError) => ({
                      ...prevError,
                      istaxapply: "", // Clear error on change
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tax Applied "
                      variant="outlined"
                      size="small"
                      name="istaxapply"
                      error={Boolean(errors.istaxapply)}
                      helperText={errors.istaxapply}
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid> */}
            {/* <Grid item xs={12} sm={12} md={6} lg={6}>
             
                            <Grid container spacing={1} mt={0}>
                              <Grid item xs={6} sm={6} md={6} lg={6} xl={6} pt={0}>
                                <Box>
                                  <ImageCropper
                                    onCropComplete={handleCroppedImage}
                                    FIXED_WIDTH={CON_MENUICON_WIDTH}
                                    FIXED_HEIGHT={CON_MENUICON_HEIGHT}
                                    MAX_FILESIZE={CON_MAX_FILESIZE_ITEMIMG}
                                    setSnackbarMessage={setSnackbarMessage}
                                    setOpenErrorSnackbar={setOpenErrorSnackbar}
                                    setMatchingItem={setSelectedItemDetails}
                                  />
                                </Box>
                              </Grid>
              
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} pt={0}>
  {(croppedImg || selectedImageUrl || selectedItem?.IMAGEPATH) && (
    <Box
      display="flex"
      flexDirection="column"
      
      gap={1}
      sx={{ mt: 2 }}
    >
    
      <Paper
        elevation={4}
  sx={{
    width: 200,
    height: 200,
    p: 1,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f9f9f9",
        }}
      ><img
  src={croppedImg ? croppedImg : selectedImageUrl || selectedItem?.IMAGEPATH}
  alt="Cropped preview"
  style={{
    width: "100%",
    maxWidth: "300px", // larger max width
    height: "auto",
    maxHeight: "300px",
    borderRadius: 8,
    objectFit: "cover",
  }}
/>

      </Paper>
    </Box>
  )}
</Grid>


                              
                            </Grid>
                        
              
               </Grid> */}

                     {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                                 <Box
                                   display={"flex"}
                                   alignItems={"center"}
                                   justifyContent={"center"}
                                   height={"100%"}
                                 >
                                   {(selectedImageUrl || selectedItem?.IMAGEPATH) && (
                                     <img
                                       src={
                                         selectedImageUrl
                                           ? `${selectedImageUrl}` // Use selectedImageUrl if available
                                           : `${selectedItem?.IMAGEPATH}` // Use matchingItem?.IMAGEPATH as fallback
                                       }
                                       alt="Selected or Matching Item"
                                       style={{
                                         // width: "100px",
                                         height: "auto",
                                         maxHeight: "100px",
                                         // marginTop: "20%",
                                         // marginLeft: marginLeftImage,
               
                                         cursor: "pointer",
                                       }}
                                     />
                                   )}
                                 </Box>
                               </Grid> */}
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default AddProduct;
